import { combineReducers } from 'redux'

import resultados from './detalhesRecursoRecebido'
import aditivosRecursoRecebido from './aditivosRecursoRecebido'
import administradorPublicoRecursoRecebido from './administradorPublicoRecursoRecebido'
import controleInternoRecursoRecebido from './controleInternoRecursoRecebido'
import cronogramaDesembolsoRecursoRecebido from './cronogramaDesembolsoRecursoRecebido'
import parecerComissaoRecursoRecebido from './parecerComissaoRecursoRecebido'
import parecerGestorRecursoRecebido from './parecerGestorRecursoRecebido'
import planoTrabalhoRecursoRecebido from './planoTrabalhoRecursoRecebido'
import resumoPrestacaoRecursoRecebido from './resumoPrestacaoRecursoRecebido'
import contratosRecebido from './contratosRecebido'
import convenentesConcedentesRecebido from './convenentesConcedentes'

export default combineReducers({
    resultados,
    aditivosRecursoRecebido,
    administradorPublicoRecursoRecebido,
    controleInternoRecursoRecebido,
    cronogramaDesembolsoRecursoRecebido,
    parecerComissaoRecursoRecebido,
    parecerGestorRecursoRecebido,
    planoTrabalhoRecursoRecebido,
    resumoPrestacaoRecursoRecebido,
    contratosRecebido,
    convenentesConcedentesRecebido,
})
